import { Component } from 'vue'
import VtLoadingButtonSpinner from '@/components/common/vt-loading-button/vt-loading-button-spinner/vt-loading-button-spinner.vue'
export interface VtLoadingButtonParams {
    promise: Function
    shortkeys?: string[]
}

export interface VTLoadingButtonState{
    loader: Component | string,
    loading:boolean
}
export const initialVTLoadingButtonState =
    (): VTLoadingButtonState => ({
        loader: VtLoadingButtonSpinner,
        loading: false
    })
